import {
  CylinderGeometry,
  Mesh,
  MeshStandardMaterial,
  Object3D,
  Vector3,
} from "three";

import { Context } from "../../context";
import { groundLevel } from "../../../lib/misc/ground";

export class BallPad extends Object3D {
  private pad: Mesh;

  material: MeshStandardMaterial;

  private maxHeight = 35;
  private contextRef: Context;

  constructor(context: Context, radius: number = 6.0, height: number = 0.05) {
    super();

    const geo = new CylinderGeometry(radius, radius, height, 40);
    this.material = new MeshStandardMaterial({
      color: "white",
      transparent: true,
      opacity: 0.5,
    });

    this.pad = new Mesh(geo, this.material);
    this.pad.visible = false;

    this.add(this.pad);

    this.contextRef = context;
  }

  update(ballPosition: Vector3) {
    const groundHeight = groundLevel(ballPosition.x, ballPosition.z);

    this.pad.visible = this.contextRef.state.padEnabled;
    this.pad.position.set(ballPosition.x, groundHeight, ballPosition.z);

    // 0.2 <= radiusScaling <= 1.0
    const radiusScaling = Math.max(
      0.2,
      Math.min(ballPosition.y / this.maxHeight, 1.0)
    );
    this.pad.scale.set(radiusScaling, 1, radiusScaling);
  }
}
